import { ReactComponent as StoreSvg } from '../../assets/icons/store.svg';

export const StoreIcon: SvgIcon = (props) => {
    return <StoreSvg {...props} />;
};
